if (!customElements.get('preorder-description-host')) {
  class PreorderDescriptionHost extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.product-info__block');
      if (!this.scope) return;

      this.syncDescription = this.syncDescription.bind(this);
      this.observer = new MutationObserver(this.syncDescription);
      this.observer.observe(this.scope, {
        childList: true,
        subtree: true,
        characterData: true
      });
      this.syncDescription();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.divider?.classList.remove('is-preorder-description-divider-hidden');
    }

    findPreorderDivider() {
      let sibling = this.scope.previousElementSibling;
      while (sibling) {
        if (sibling.tagName === 'HR') return sibling;
        sibling = sibling.previousElementSibling;
      }
      return null;
    }

    setDividerHidden(hidden) {
      const divider = this.findPreorderDivider();
      if (this.divider && this.divider !== divider) {
        this.divider.classList.remove('is-preorder-description-divider-hidden');
      }
      this.divider = divider;
      this.divider?.classList.toggle('is-preorder-description-divider-hidden', hidden);
    }

    syncDescription() {
      const source = this.scope.querySelector(
        'product-form .hengam-preorder-description:not(.hengam-preorder-description--external)'
      );
      const sourcePortal = source?.closest('.nm-portal');

      this.scope.querySelectorAll('.nm-portal.is-preorder-description-source').forEach((portal) => {
        portal.classList.toggle('is-preorder-description-source', portal === sourcePortal);
      });

      if (!source || !sourcePortal) {
        if (this.descriptionSignature !== null) this.replaceChildren();
        this.descriptionSignature = null;
        this.setDividerHidden(false);
        this.hidden = true;
        return;
      }

      sourcePortal.classList.add('is-preorder-description-source');
      this.setDividerHidden(true);
      const signature = `${source.textContent}\u0000${source.getAttribute('style') || ''}`;

      if (signature !== this.descriptionSignature) {
        const description = source.cloneNode(true);
        description.removeAttribute('id');
        description.classList.add('hengam-preorder-description--external');
        this.replaceChildren(description);
        this.descriptionSignature = signature;
      }

      this.hidden = false;
    }
  }

  customElements.define('preorder-description-host', PreorderDescriptionHost);
}
